import { emit, isChatDisabled, updateChatState, updateMessage } from "../../../core/state.js";
import { getUiFeature } from "../../../core/configAccessors.js";

const DEFAULT_ICON = `<svg width="7" height="14" viewBox="0 0 7 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bolt-icon">
  <path d="M6.14459 0.952148V0.953125C6.20166 0.947137 6.25921 0.955745 6.31061 0.981445L6.38287 1.03223L6.43756 1.10254V1.10352L6.46588 1.1748C6.47233 1.19988 6.47565 1.22579 6.47565 1.25195C6.47564 1.30404 6.4622 1.35488 6.43756 1.40039L6.43658 1.40332L4.19635 4.95117H6.14459C6.20177 4.94517 6.25917 4.95567 6.31061 4.98145C6.33716 4.99478 6.36155 5.01199 6.38287 5.03223L6.43756 5.10156L6.43854 5.10352L6.46783 5.19238L6.46881 5.28613C6.46029 5.34543 6.43321 5.39957 6.39362 5.44434L6.39459 5.44531L1.40045 12.9443L1.39362 12.9551L1.39264 12.9541C1.32666 13.0142 1.24066 13.0481 1.15143 13.0498H1.05573L1.04498 13.0449C0.997691 13.0216 0.958258 12.9859 0.929749 12.9424L0.905334 12.8965C0.884686 12.8481 0.877222 12.7956 0.88385 12.7441L0.894592 12.6934L2.29108 7.55078H0.642639V7.5498C0.57027 7.53775 0.5032 7.50474 0.450256 7.4541L0.444397 7.44824L0.440491 7.44043C0.430484 7.42052 0.421058 7.40399 0.411194 7.38574C0.401839 7.36843 0.391504 7.34907 0.384827 7.3291C0.370831 7.28695 0.372423 7.24431 0.395569 7.19434L1.89069 1.2041C1.8956 1.13885 1.92467 1.07736 1.97076 1.03125L2.00885 1C2.04907 0.972242 2.09615 0.95548 2.14557 0.952148H6.14459ZM1.04791 6.95117H2.64948C2.70114 6.95079 2.75182 6.96447 2.79596 6.99121C2.83559 7.01523 2.86637 7.05003 2.88971 7.08984L2.93365 7.14648C2.94521 7.16738 2.95334 7.19017 2.95807 7.21387L2.961 7.28516C2.95863 7.30647 2.9516 7.32663 2.94342 7.34668L2.94537 7.34766L1.94342 11.0488L5.59186 5.55176H3.64557V5.55078C3.61966 5.55097 3.5941 5.54784 3.5694 5.54102L3.49908 5.51074C3.45483 5.48391 3.4191 5.44542 3.39557 5.39941V5.40039C3.37122 5.35469 3.35846 5.30276 3.35846 5.25098C3.35854 5.19935 3.3713 5.14811 3.39557 5.10254L3.39752 5.09961L5.63873 1.55176H2.39557L1.04791 6.95117Z" fill="currentColor" stroke="currentColor" stroke-width="0.1"/>
  </svg>`;

// Named icons referenced by guided_flow_questions[].icon = '<name>'.
// Extend by adding entries here; unknown names fall back to DEFAULT_ICON.
const NAMED_ICONS = {
  bolt:   `<svg width="7" height="14" viewBox="0 0 7 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bolt-icon">
  <path d="M6.14459 0.952148V0.953125C6.20166 0.947137 6.25921 0.955745 6.31061 0.981445L6.38287 1.03223L6.43756 1.10254V1.10352L6.46588 1.1748C6.47233 1.19988 6.47565 1.22579 6.47565 1.25195C6.47564 1.30404 6.4622 1.35488 6.43756 1.40039L6.43658 1.40332L4.19635 4.95117H6.14459C6.20177 4.94517 6.25917 4.95567 6.31061 4.98145C6.33716 4.99478 6.36155 5.01199 6.38287 5.03223L6.43756 5.10156L6.43854 5.10352L6.46783 5.19238L6.46881 5.28613C6.46029 5.34543 6.43321 5.39957 6.39362 5.44434L6.39459 5.44531L1.40045 12.9443L1.39362 12.9551L1.39264 12.9541C1.32666 13.0142 1.24066 13.0481 1.15143 13.0498H1.05573L1.04498 13.0449C0.997691 13.0216 0.958258 12.9859 0.929749 12.9424L0.905334 12.8965C0.884686 12.8481 0.877222 12.7956 0.88385 12.7441L0.894592 12.6934L2.29108 7.55078H0.642639V7.5498C0.57027 7.53775 0.5032 7.50474 0.450256 7.4541L0.444397 7.44824L0.440491 7.44043C0.430484 7.42052 0.421058 7.40399 0.411194 7.38574C0.401839 7.36843 0.391504 7.34907 0.384827 7.3291C0.370831 7.28695 0.372423 7.24431 0.395569 7.19434L1.89069 1.2041C1.8956 1.13885 1.92467 1.07736 1.97076 1.03125L2.00885 1C2.04907 0.972242 2.09615 0.95548 2.14557 0.952148H6.14459ZM1.04791 6.95117H2.64948C2.70114 6.95079 2.75182 6.96447 2.79596 6.99121C2.83559 7.01523 2.86637 7.05003 2.88971 7.08984L2.93365 7.14648C2.94521 7.16738 2.95334 7.19017 2.95807 7.21387L2.961 7.28516C2.95863 7.30647 2.9516 7.32663 2.94342 7.34668L2.94537 7.34766L1.94342 11.0488L5.59186 5.55176H3.64557V5.55078C3.61966 5.55097 3.5941 5.54784 3.5694 5.54102L3.49908 5.51074C3.45483 5.48391 3.4191 5.44542 3.39557 5.39941V5.40039C3.37122 5.35469 3.35846 5.30276 3.35846 5.25098C3.35854 5.19935 3.3713 5.14811 3.39557 5.10254L3.39752 5.09961L5.63873 1.55176H2.39557L1.04791 6.95117Z" fill="currentColor" stroke="currentColor" stroke-width="0.1"/>
  </svg>`
  };

function resolveIcon(item) {
  if (typeof item !== "object" || !item.icon) return DEFAULT_ICON;
  // if (typeof item.icon !== "string") return DEFAULT_ICON;
  // const named = NAMED_ICONS[item.icon];
  // if (named) return named;
  // If the value looks like inline SVG/HTML markup, honor it.
  if (item.icon.includes("<")) return item.icon;
  return DEFAULT_ICON;
}

// ⚠ SHARED/BASE — affects ALL tenants. visible_when keys map to
// config.ui_features keys. Item is hidden when any key/value pair does not match.
// Missing ui_features key reads as null and is always treated as mismatch.
// The expected value arrives as a STRING ("true"/"false") from tenant config
// (all config values are strings) or as a boolean from a variant list — coerce
// it to a boolean so it matches getUiFeature's coerced boolean.
function isVisible(item) {
  if (typeof item !== "object" || !item.visible_when) return true;
  for (const [key, expected] of Object.entries(item.visible_when)) {
    const want = expected === true || expected === "true";
    if (getUiFeature(key, null) !== want) return false;
  }
  return true;
}

export default class PromptList {
  render(message) {
    const items = message.data?.items || [];
    if (!items.length) return null;

    const visibleItems = items.filter((item) => isVisible(item));
    if (!visibleItems.length) return null;

    const selectedValue = message.data?.selectedValue;

    const wrap = document.createElement("div");
    wrap.className = "ws-prompts";
    // Follow-up recommendation chips (chat-handler's `source: "recommendations"`)
    // get a modifier so a tenant can size them as one block — the old widget gave
    // exactly these buttons `.same-opt-btn` (width:100%) while the welcome/guided
    // buttons stayed shrink-to-text. Structural hook only: base CSS styles nothing
    // off it, so tenants that never had .same-opt-btn are unchanged.
    if (message.data?.source === "recommendations") {
      wrap.classList.add("ws-prompts--recommendations");
    }

    let isSpecialPrompt = false;

    visibleItems.forEach((item) => {
      const label = typeof item === "string" ? item : item.label;
      const value = typeof item === "string" ? item : item.value || item.label;
      const specialPrompts = ['__register__', '__login__'];
      if (!label) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ws-prompt-chip";
      if (value === selectedValue) btn.classList.add("is-selected");

      if(!isSpecialPrompt && specialPrompts.some(item=>item===value)){
        wrap.style="flex-direction: row;";
        isSpecialPrompt = true;
      }

      const icon = document.createElement("span");
      icon.className = "ws-prompt-icon";
      icon.innerHTML = resolveIcon(item);
      btn.appendChild(icon);

      const text = document.createElement("span");
      text.className = "ws-prompt-label";
      text.textContent = label;
      btn.appendChild(text);

      btn.addEventListener("click", () => {
        if(isChatDisabled()) return;
        btn.classList.add("is-selected");
        // Persist which chip was picked into the message itself (not just a
        // DOM class) so it survives a re-render — history replay on reload
        // otherwise rebuilds this list from scratch with no selection.
        updateMessage(message.id, { selectedValue: value });
        const payload = {
          label,
          value,
        };
        if (typeof item === "object" && item.quizStatus) {
          payload.quizStatus = item.quizStatus;
        }
        if (typeof item === "object" && item.suppressUserBubble) {
          payload.suppressUserBubble = true;
        }
        emit("ws-prompt-select", payload);
      });

      wrap.appendChild(btn);
    });

    return wrap;
  }
}
